import React from 'react';

const daysInFrench = {
  Su: 'Dimanche',
  Mo: 'Lundi',
  Tu: 'Mardi',
  We: 'Mercredi',
  Th: 'Jeudi',
  Fr: 'Vendredi',
  Sa: 'Samedi'
};

export const formatOpeningHours = (hoursString: string) => {
  return hoursString.split(';').map((item, index) => {
    const match = item.match(/(\w{2})\s([\d:,]+[-\d:,]+)/);
    if (match) {
      const day = daysInFrench[match[1] as keyof typeof daysInFrench];
      const hours = match[2].replace(/,/g, ' - ');
      return (
        <div key={index} className="mb-3">
          <strong>{day}</strong>: {hours}
        </div>
      );
    }
    return null;
  });
};
